const portraits = [
  {
    artistName: "Vincent van Gogh",
    code: "Vincent+van+Gogh",
    country: "Zundert - Dutchland",
    artistUrl:
      "https://lh3.googleusercontent.com/Ckjq-HkB2XhEsbuMsei0MR5fLTODfkcXY8qQTG-XLHVxE0jLO9DnSYaVE8n1kCrcm9AMKzoWB2w03LrY0v7eoj5hYw=s500-c",
    description:
      "In only a decade, Van Gogh created a prolific body of more than 2,000 works of art. Most of his 1,100 drawings and works on paper and nearly 900 oil paintings were produced during the last years of his life.",
    deathDate: 1890,
    birthDate: 1853,
    artMovement: "Post-Impressionism",
  },
  {
    artistName: "Johannes Vermeer",
    code: "Johannes+Vermeer",
    country: "Delft - Dutchland",
    artistUrl:
      "https://cdn.shopify.com/s/files/1/0549/9656/6169/collections/f9d875b00a67804b65c357e98c96cb89_1600x.png?v=1616592266",
    description:
      " He was a Dutch Baroque Period painter who specialized in domestic interior scenes of middle-class life. During his lifetime, he was a moderately successful provincial genre painter, recognized in Delft and The Hague.",
    deathDate: 1675,
    birthDate: 1632,
    artMovement: "Baroque",
  },
  {
    artistName: "Rembrandt van Rijn",
    code: "Rembrandt+van+Rijn",
    country: "Leiden - Dutchland",
    artistUrl: "https://i.ibb.co/TTmQGbM/rembrandt-1.jpg",
    description:
      "Rembrandt Harmenszoon van Rijn known as Rembrandt was a Dutch draughtsman, painter, and printmaker became famous. An innovative and prolific master in three media, he is generally considered one of the greatest visual artists in the history of art.",
    deathDate: 1669,
    birthDate: 1606,
    artMovement: "Baroque",
  },
  {
    artistName: "Jan Asselijn",
    code: "Jan+Asselijn",
    country: "Dieppe - France",
    artistUrl: "https://i.ibb.co/CMVb8Zt/Jan-Asselyn-1.jpg",
    description:
      "Asselijn was born at Dieppe from a French Huguenot family as Jean Asselin. He distinguished himself particularly in landscape and animal painting though his historical works. He was a pupil of the French painter Nicolas de Largillière.",
    deathDate: 1610,
    birthDate: 1652,
    artMovement: "Baroque",
  },
];

export default portraits;
